import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { budgetQueryOptions } from '@/features/budget/api'
import { BudgetWorkspace } from '@/features/budget/pages/budget-workspace'
import { weddingSuppliersQueryOptions } from '@/features/suppliers/api'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/budget')({
  validateSearch: z.object({
    filter: z.enum(['all', 'unpaid', 'overdue', 'paid']).optional().catch(undefined),
  }),
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(budgetQueryOptions(params.workspaceSlug)),
      context.queryClient.ensureQueryData(weddingSuppliersQueryOptions(params.workspaceSlug)),
    ]),
  component: BudgetRoute,
})
function BudgetRoute() {
  const { workspaceSlug } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <BudgetWorkspace
      workspaceSlug={workspaceSlug}
      canWrite={workspace.data?.role !== 'viewer'}
      filter={search.filter ?? 'all'}
      onFilterChange={(filter) =>
        navigate({
          search: (current) => ({ ...current, filter: filter === 'all' ? undefined : filter }),
          replace: true,
        })
      }
    />
  )
}
